import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const PrivacyPolicy = () => {
  const { currentUser } = useApp();
  const homeLink = currentUser ? '/events' : '/login';

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <Link to={homeLink} style={{
          color: '#007bff',
          textDecoration: 'none',
          fontSize: '1rem',
          padding: '0.5rem 1rem',
          border: '1px solid #007bff',
          borderRadius: '4px',
          display: 'inline-block'
        }}>← Back to {currentUser ? 'Events' : 'Login'}</Link>
      </div>

      <h1 style={{ textAlign: 'center', marginBottom: '0.5rem', color: '#333' }}>Privacy Policy</h1>
      <p style={{ textAlign: 'center', color: '#6c757d', marginBottom: '2rem' }}>Last updated: {new Date().getFullYear()}</p>

      <div style={{ display: 'grid', gap: '1.5rem' }}>
        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Information We Collect</h2>
          <p>
            We collect account information (such as your name, email, and phone number), scheduling and training
            records you or your organization enter, and basic usage data needed to operate the application.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#28a745', borderBottom: '2px solid #28a745', paddingBottom: '0.5rem' }}>How We Use Information</h2>
          <p>
            Information is used to provide flight scheduling, training tracking, communications, and payment
            features within the platform, and to keep your account secure. We do not sell your personal information.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: '0.5rem' }}>Third-Party Services</h2>
          <p>
            We may share limited information with trusted service providers (such as payment processors, weather
            data providers, and Google Calendar when you choose to connect it) solely to deliver the features you use.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#6f42c1', borderBottom: '2px solid #6f42c1', paddingBottom: '0.5rem' }}>Data Retention & Security</h2>
          <p>
            We retain information for as long as your account is active or as needed to provide our services, and
            we use reasonable administrative and technical safeguards to protect it.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#fd7e14', borderBottom: '2px solid #fd7e14', paddingBottom: '0.5rem' }}>Your Choices</h2>
          <p>
            You can review and update your account information at any time, and you can disconnect any connected
            third-party service (such as Google Calendar) from your account settings.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Contact Us</h2>
          <p>
            Questions about this policy can be sent through our <Link to="/contact" style={{ color: '#007bff' }}>Contact page</Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
